import { useSalesV2 } from "modules/admin_dashboard/store";
import CardDiv from "modules/common/card-div/CardDiv";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import {
  activeBDEFn,
  aovOrdersFn,
  bookedSlotsFn,
  calcOrdersRevenue,
  formStatusFn,
  leadActionReportFn,
  orderReportFn,
  ordersInfoFn,
  voidOrdersFn,
  totalLeads,
  bookingsFn,
  noBookingsFn,
  downloadCSV,
} from "modules/admin_dashboard/common_sales_function";
import LeadsInfo from "modules/admin_dashboard/LeadsInfo";
import FromStatus from "modules/admin_dashboard/FromStatus";
import LeadActionReport from "modules/admin_dashboard/LeadActionReport";
import OrderReport from "modules/admin_dashboard/OrderReport";
import ScheduleComplete from "modules/admin_dashboard/ScheduleComplete";
import { Tabs } from "antd";
import { isDownloadDisabled } from "modules/utilities/utility";
import { userAllAuthDashBoardLeadStats } from "./store";
import SalesOrderReport from "modules/admin_dashboard/SalesAgentOrders";
// import { Tab, Tabs } from "react-bootstrap";

function SalesDashboard() {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [key, setKey] = useState("leadAction");
  const { fetchAllAuthDashBoardLeadStats, allAuthDashBoardLeadStats, isLoading } = userAllAuthDashBoardLeadStats();
  useEffect(() => {
    const startValue = moment(startDate).startOf("day").format("YYYY-MM-DD");
    const endValue = moment(endDate).endOf("day").toISOString();
    fetchAllAuthDashBoardLeadStats(startValue);
  }, [startDate, endDate]);


  const handleClear = () => {
    setStartDate(new Date());
    setEndDate(new Date());
  };

  const tabArray = ["Cold Calls", "Slot Calls", "COD Orders", "UTM Orders", "Prepaid Orders"];
  const tabComponent = {
    "Cold Calls": (
      <LeadActionReport
        isLoading={isLoading}
        allAuthDashBoardLeadStats={ allAuthDashBoardLeadStats.coldCallOfAgent ?? {} }
      />
    ),
    "Slot Calls": (
      <OrderReport isLoading={isLoading}
        allAuthDashBoardLeadStats={ allAuthDashBoardLeadStats.slotCallOfAgent ?? {} }
      />
    ),
    "COD Orders": (
      <SalesOrderReport isLoading={isLoading}
        allAuthDashBoardLeadStats={ allAuthDashBoardLeadStats.agentCodOrders ?? {} }
      />
    ),
    "UTM Orders": (
      <SalesOrderReport isLoading={isLoading}
        allAuthDashBoardLeadStats={ allAuthDashBoardLeadStats.agentUtmOrders ?? {} }
      />
    ),
    "Prepaid Orders": (
      <SalesOrderReport isLoading={isLoading}
        allAuthDashBoardLeadStats={ allAuthDashBoardLeadStats.agentPrepaidOrders ?? {} }
      />
    )
  };

return (
  <div>
    <CardDiv
      title={
        <div className="d-flex gap-2 my-n2 justify-content-between align-items-center">
          <div className="fs-2" style={{ fontFamily: "poppins" }}>
            Sales Dashboard
          </div>
          <div className="d-flex gap-2">
            <div>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                formatWeekDay={(day) => day.slice(0, 3)}
                className="form-control"
                placeholderText="Select Date"
                maxDate={new Date()}
              />
            </div>
            <button className="btn btn-primary" onClick={handleClear}>
              Clear
            </button>

          </div>
        </div>
      }
      component={
        <div className="mt-n2">

          <FromStatus
           
            isLoading={isLoading}
            allAuthDashBoardLeadStats={allAuthDashBoardLeadStats ?? {}}
          />
          <div className="card mt-2 p-2">
            <Tabs
              // onChange={onChange}
              type="card"
              items={tabArray.map((item, index) => {
                const id = String(index + 1);
                return {
                  label: item,
                  key: id,
                  children: tabComponent[item],
                };
              })}
            />
          </div>
        </div>
      }
    />
  </div>
);
}

export default SalesDashboard;
